var Swiper = require('swiper');

(function () {

    $(window).on("load", function () {
        var $alertBanner = $('.alert-banner');
        var $alertBannerClose = $('.alert-banner__close-icon');

        function checkCookie(name, value) {
            var hasCookie = document.cookie.split(';').some(
                function (item) {
                    return item.trim().includes(name + '=' + value);
                }
            );

            return hasCookie;
        }

        function closeBanner() {
            document.cookie = "alertBannerClosed=true;";
            $alertBanner.slideUp();
        }

        function setHeight() {
            var $contentArea = $('.layout-main');
            var $headerHeight = $('.site-header').outerHeight();
            if ($contentArea.css('margin-top') == $headerHeight) {
                return;
            } else {
                $contentArea.css('margin-top', $headerHeight);
            }
            function setMobileHeight() {
                var $alertHeight = $('.alert-banner').outerHeight();
                var $siteBranding = $('.site-branding');

                var computedHeight = $alertHeight + 10;

                $siteBranding.css('top', computedHeight);
            }
            if (window.innerWidth < 768) {
                setMobileHeight();
            }
        }

        function removeHeight() {
            window.removeEventListener('resize', setHeight);
            var $contentArea = $('.layout-main');

            $contentArea.css('margin-top', "");

            function removeMobileHeight() {
                $siteBranding = $('.site-branding');
                $siteBranding.css('top', '');
            }

            if (window.innerWidth < 768) {
                removeMobileHeight();
            }
        }

        function initAlert() {
            if (checkCookie('alertBannerClosed', 'true') == true) {
                closeBanner();
            } else {
                $alertBanner.slideDown(400, function () {
                    var $headerHeight = $('.site-header').outerHeight();
                    setHeight();
                });
                window.addEventListener('resize', setHeight);
            }
        }

        $alertBannerClose.click(function () {
            closeBanner();
            removeHeight();
        });

        initAlert();

        var nx = document.querySelector('.alert-banner__nav-arrow--right');
        var pv = document.querySelector('.alert-banner__nav-arrow--left');
        var pagination = document.querySelector('.alert-banner__dot-list');
        var slideCountEl = document.querySelector('[slide-count]');
        var slideCount = slideCountEl ? slideCountEl.getAttribute('slide-count') : 0;

        function initSwiper() {
            var swiper = new Swiper('.alert-banner__slider-wrapper', {
                loop: parseInt(slideCount) == 1 ? false : true,
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                    el: pagination,
                },
                navigation: {
                    nextEl: nx,
                    prevEl: pv,
                },
                autoHeight: true,
                observer: true,
                on: {
                    slideChangeTransitionEnd: function () {
                        setHeight();
                    }
                }
            })
        }
        initSwiper();
        setHeight();

    });

    // $(window).on("load", function() {
    //     var nx = document.querySelector('.alert-banner__nav-arrow--right');
    //     var pv = document.querySelector('.alert-banner__nav-arrow--left');
    //     var pagination = document.querySelector('.alert-banner__dot-list');

    //     function initSwiper() {
    //         var swiper = new Swiper('.alert-banner__slider-wrapper', {
    //             loop: true,
    //             slidesPerView: 1,
    //             spaceBetween: 10,
    //             pagination: {
    //                 el: pagination,
    //             },
    //             navigation: {
    //                 nextEl: nx,
    //                 prevEl: pv,
    //             },
    //             autoHeight: true,
    //             observer: true,
    //             on: {
    //                 slideChange: function() {
    //                     setHeight();
    //                 }
    //             } 
    //         })
    //     }
    //     initSwiper();
    // });

})();
